import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { string, num, getThemeValue, negative, warn, merge, assign, func, is, obj, cascade } from '@xstyled/util';
var __pow = Math.pow;

var round = function round(value) {
  return Math.round(value * __pow(10, 4)) / __pow(10, 4);
};

var unit = function unit(unit2) {
  return function (value) {
    return num(value) && value !== 0 ? "".concat(value).concat(unit2) : value;
  };
};

var ms = unit("ms");
var px$1 = unit("px");
var deg = unit("deg");

var pxToRem = function pxToRem(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$rootFontSize = _ref.rootFontSize,
      rootFontSize = _ref$rootFontSize === void 0 ? 16 : _ref$rootFontSize;

  return round(value / rootFontSize);
};

var remPx = function remPx(value, options) {
  var num2 = Number(value);
  if (Number.isNaN(num2) || num2 === 0) return value;
  return "".concat(pxToRem(num2, options), "rem");
};

var rpx = function rpx(value, options) {
  if (!string(value) || value.length < 4) return value;
  var unit2 = value.slice(-3);
  if (unit2 !== "rpx") return value;
  var n = Number(value.slice(0, value.length - 3));
  if (n === 0) return 0;
  return "".concat(pxToRem(n, options), "rem");
};

var percent = function percent(n) {
  return num(n) && n !== 0 && n >= -1 && n <= 1 ? "".concat(round(n * 100), "%") : n;
};

var transformNegative = function transformNegative(_, _ref2) {
  var rawValue = _ref2.rawValue,
      variants = _ref2.variants,
      props = _ref2.props;

  if (string(rawValue)) {
    var neg = rawValue.startsWith("-");
    var abs = neg ? rawValue.substr(1) : rawValue;
    var varVal = getThemeValue(props, abs, variants);
    var value = string(varVal) || num(varVal) ? varVal : abs;
    return neg ? "-".concat(value) : value;
  }

  if (num(rawValue)) {
    var _neg = negative(rawValue);

    var _abs = Math.abs(rawValue);

    var _varVal = variants ? variants[_abs] : void 0;

    if (string(_varVal)) return _neg ? "-".concat(_varVal) : _varVal;

    var _value = num(_varVal) ? _varVal : _abs;

    return _neg ? _value * -1 : _value;
  }

  return void 0;
};

var mediaMinWidth = function mediaMinWidth(value) {
  return value ? "@media (min-width: ".concat(value, ")") : null;
};

var mediaMaxWidth = function mediaMaxWidth(value) {
  return value ? "@media (max-width: ".concat(value, ")") : null;
};

var mediaBetweenWidth = function mediaBetweenWidth(min, max) {
  return min && max ? "@media (min-width: ".concat(min, ") and (max-width: ").concat(max, ")") : null;
};

var getBreakpointMin = function getBreakpointMin(screens, key) {
  var value = screens[key];
  return value === 0 ? null : px$1(value);
};

var getBreakpointMax = function getBreakpointMax(screens, key) {
  var value = screens[key];
  return value === 0 ? null : px$1(value - 0.02);
};

var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$6 = function __defNormalProp$6(obj, key, value) {
  return key in obj ? __defProp$6(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues$6 = function __spreadValues$6(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$6) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols$6(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum$6.call(b, prop)) __defNormalProp$6(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var getScreens = function getScreens(props) {
  return props.theme && props.theme.screens ? props.theme.screens : {};
};

var getStates = function getStates(props) {
  return props.theme && props.theme.states ? props.theme.states : {};
};

var getVariants = function getVariants(props) {
  var screens = getScreens(props);
  var states = getStates(props);
  var medias = {};

  for (var value in screens) {
    medias[value] = mediaMinWidth(getBreakpointMin(screens, value));
  }

  var variants = __spreadValues$6(__spreadValues$6({}, medias), states);

  for (var _i = 0, _Object$entries = Object.entries(variants); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _value2 = _Object$entries$_i[0],
        selector = _Object$entries$_i[1];

    if (selector && selector.startsWith("@")) {
      delete variants[_value2];
      variants[_value2] = selector;
    }
  }

  return variants;
};

var getCachedVariants = function getCachedVariants(props, cache) {
  if (cache.has("_variants")) return cache.get("_variants");
  var states = getVariants(props);
  cache.set("_variants", states);
  return states;
};

var cacheSupported = typeof Map !== "undefined" && typeof WeakMap !== "undefined";
var caches = cacheSupported ? /* @__PURE__ */new WeakMap() : null;

var isCacheDisabled = function isCacheDisabled(theme) {
  var _a;

  return ((_a = theme == null ? void 0 : theme.xstyled) == null ? void 0 : _a.cache) === false;
};

var getThemeCache = function getThemeCache(theme) {
  var cacheDisabled = isCacheDisabled(theme);
  if (cacheDisabled) return null;
  if (caches === null) return null;
  if (caches.has(theme)) return caches.get(theme) || null;
  var cache = {};
  caches.set(theme, cache);
  return cache;
};

var noopCache = {
  has: function has() {
    return false;
  },
  set: function set() {
    return void 0;
  },
  get: function get() {
    return void 0;
  }
};

var getCache = function getCache(theme, namespace) {
  if (!theme) return noopCache;
  var cache = getThemeCache(theme);
  if (!cache || !theme) return noopCache;
  cache[namespace] = cache[namespace] || /* @__PURE__ */new Map();
  return cache[namespace];
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$5 = function __defNormalProp$5(obj2, key, value) {
  return key in obj2 ? __defProp$5(obj2, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj2[key] = value;
};

var __spreadValues$5 = function __spreadValues$5(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$5) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols$5(b)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (__propIsEnum$5.call(b, prop)) __defNormalProp$5(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return a;
};

var themeGetterId = 0;
var SPLITTERS = {
  shorthand: [/\s+/, " "],
  multiple: [/\s*,\s*/, ","]
};

var splitValue = function splitValue(splitter, transform) {
  return function (value) {
    return value.split(splitter[0]).map(transform).join(splitter[1]);
  };
};

var themeGetter = function themeGetter(_ref3) {
  var name = _ref3.name,
      defaultTransform = _ref3.transform,
      key = _ref3.key,
      compose2 = _ref3.compose,
      shorthand = _ref3.shorthand,
      multiple = _ref3.multiple;
  var id = themeGetterId++;

  var getter = function getter(value, defaultValue) {
    return function (props) {
      var res = value;

      if (!string(value) && !num(value) && value !== true) {
        return res;
      }

      var cacheKey = "".concat(typeof value, "-").concat(value, "-").concat(defaultValue);
      var cache = getCache(props.theme, "__themeGetter".concat(id));
      if (cache.has(cacheKey)) return cache.get(cacheKey);

      var getValue = function getValue(value2) {
        var localDefaultValue = is(defaultValue) ? defaultValue : value2;
        var res2 = value2;
        var variants = is(key) ? getThemeValue(props, key) : null;

        if (is(variants)) {
          var path = value2 === true ? "default" : string(value2) || num(value2) ? value2 : null;

          if (is(path)) {
            var fromTheme = getThemeValue(props, path, variants);
            res2 = Array.isArray(fromTheme) ? fromTheme.join(",") : fromTheme;
          }
        }

        var rawValue = value2;

        if (!is(res2)) {
          rawValue = localDefaultValue;
          res2 = localDefaultValue;
        }

        var transform = (name && props.theme && props.theme.transformers ? props.theme.transformers[name] : null) || defaultTransform;

        if (transform) {
          res2 = transform(res2, {
            rawValue: rawValue,
            variants: variants,
            props: props
          });
        }

        return compose2 ? compose2(res2)(props) : res2;
      };

      if ((shorthand || multiple) && string(value)) {
        var _transform = getValue;
        if (shorthand) _transform = splitValue(SPLITTERS.shorthand, _transform);
        if (multiple) _transform = splitValue(SPLITTERS.multiple, _transform);
        res = _transform(value);
      } else {
        res = getValue(value);
      }

      cache.set(cacheKey, res);
      return res;
    };
  };

  getter.meta = {
    name: name,
    transform: defaultTransform
  };
  return getter;
};

var createStyleGenerator = function createStyleGenerator(_ref4) {
  var getStyle = _ref4.getStyle,
      props = _ref4.props,
      _ref4$cssGetters = _ref4.cssGetters,
      cssGetters = _ref4$cssGetters === void 0 ? {} : _ref4$cssGetters,
      generators = _ref4.generators;
  var generator = getStyle;
  generator.meta = {
    props: props,
    cssGetters: cssGetters,
    getStyle: generator,
    generators: generators
  };

  generator.apply = function (values) {
    return function (_ref5) {
      var theme = _ref5.theme;
      return generator(__spreadValues$5({
        theme: theme
      }, values));
    };
  };

  return generator;
};

var reduceVariants = function reduceVariants(props, values, getStyle) {
  var cache = getCache(props.theme, "__variants");
  var variants = getCachedVariants(props, cache);
  var styles = {};

  for (var value in values) {
    var style2 = getStyle(values[value]);
    if (style2 === null) continue;
    var state = value in variants ? variants[value] : value;
    if (state === void 0) continue;

    if (state === null) {
      styles = merge(styles, style2);
    } else {
      styles[state] = styles[state] ? assign(styles[state], style2) : style2;
    }
  }

  return styles;
};

var getStyleFactory = function getStyleFactory(prop, mixin, themeGet) {
  return function (props) {
    var fromValue = function fromValue(value2) {
      if (!is(value2)) return null;
      if (obj(value2)) return reduceVariants(props, value2, fromValue);
      return cascade(mixin(themeGet ? themeGet(value2)(props) : value2), props);
    };

    var value = props[prop];
    if (!is(value)) return null;
    var cache = getCache(props.theme, prop);
    var key = obj(value) ? JSON.stringify(value) : value;
    if (cache.has(key)) return cache.get(key);
    var style2 = fromValue(value);
    cache.set(key, style2);
    return style2;
  };
};

var indexGeneratorsByProp = function indexGeneratorsByProp(generators) {
  var index = {};

  for (var i = 0; i < generators.length; i++) {
    var style2 = generators[i];

    if (style2 && style2.meta) {
      for (var j = 0; j < style2.meta.props.length; j++) {
        var prop = style2.meta.props[j];
        index[prop] = style2;
      }
    }
  }

  return index;
};

var sortStyles = function sortStyles(styles, variants) {
  for (var key in variants) {
    var variant = variants[key];
    var style2 = styles[variant];
    if (!style2) continue;
    delete styles[variant];
    styles[variant] = style2;
  }

  return styles;
};

function compose() {
  var flatGenerators = [];

  for (var _len = arguments.length, generators = new Array(_len), _key = 0; _key < _len; _key++) {
    generators[_key] = arguments[_key];
  }

  generators.forEach(function (gen) {
    warn(Boolean(gen), "Undefined generator in \"compose\" method");
    if (!gen) return;

    if (gen.meta.generators) {
      flatGenerators = [].concat(_toConsumableArray(flatGenerators), _toConsumableArray(gen.meta.generators));
    } else {
      flatGenerators.push(gen);
    }
  });
  var generatorsByProp = indexGeneratorsByProp(flatGenerators);

  var getStyle = function getStyle(props2) {
    var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var styles = {};
    var merged;

    for (var key in props2) {
      var generator = generatorsByProp[key];

      if (generator) {
        var style2 = generator.meta.getStyle(props2, false);
        merge(styles, style2);
        merged = true;
      }
    }

    if (!merged || !sort) return styles;
    var medias = getCachedVariants(props2, getCache(props2.theme, "__states"));
    return sortStyles(styles, medias);
  };

  var props = [];
  var cssGetters = {};

  for (var i = 0; i < flatGenerators.length; i++) {
    var generator = flatGenerators[i];
    props.push.apply(props, _toConsumableArray(generator.meta.props));
    Object.assign(cssGetters, generator.meta.cssGetters);
  }

  return createStyleGenerator({
    getStyle: getStyle,
    props: props,
    cssGetters: cssGetters,
    generators: generators
  });
}

var getMixinFromCSSProperties = function getMixinFromCSSProperties(properties) {
  return function (value) {
    if (string(properties)) return _defineProperty({}, properties, value);
    var style2 = {};

    for (var key in properties) {
      style2[properties[key]] = value;
    }

    return style2;
  };
};

var getMixinFromCSSOption = function getMixinFromCSSOption(css) {
  if (func(css)) return css;
  return getMixinFromCSSProperties(css);
};

var dasherize = function dasherize(key) {
  return key.replace(/[A-Z]/g, "-$&").toLowerCase();
};

var style = function style(_ref7) {
  var prop = _ref7.prop,
      css = _ref7.css,
      themeGet = _ref7.themeGet,
      key = _ref7.key,
      transform = _ref7.transform,
      cssPropsOption = _ref7.cssProps;
  var getter = themeGet || (key || transform ? themeGetter({
    key: key,
    transform: transform
  }) : void 0);
  var cssProps = cssPropsOption || (string(css) ? [css] : Array.isArray(css) ? css : string(prop) ? [prop] : Array.isArray(prop) ? prop : []);

  if (Array.isArray(prop)) {
    var mixin2 = css ? getMixinFromCSSOption(css) : css;
    var generators2 = prop.map(function (prop2) {
      return style({
        prop: prop2,
        css: mixin2,
        cssProps: cssProps,
        themeGet: getter
      });
    });
    return compose.apply(void 0, _toConsumableArray(generators2));
  }

  var props = [prop];
  var mixin = getMixinFromCSSOption(css || props);
  var generators = [];
  var getStyle = getStyleFactory(prop, mixin, getter);
  var cssGetters = getter ? cssProps.reduce(function (getters, cssProp) {
    getters[dasherize(cssProp)] = getter;
    return getters;
  }, {}) : {};
  var generator = createStyleGenerator({
    getStyle: getStyle,
    props: props,
    cssGetters: cssGetters
  });
  generators.push(generator);
  return compose.apply(void 0, generators);
};

var getPx = themeGetter({
  name: "px",
  transform: function transform(value, _ref8) {
    var props = _ref8.props;

    var _a, _b, _c;

    var rootFontSize = (_c = (_b = (_a = props == null ? void 0 : props.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.rootFontSize) != null ? _c : void 0;
    var num = Number(value);
    return px$1(rpx(Number.isNaN(num) ? value : num, {
      rootFontSize: rootFontSize
    }));
  }
});
var getDuration = themeGetter({
  name: "duration",
  key: "durations",
  transform: function transform(value) {
    var num = Number(value);
    return ms(Number.isNaN(num) ? value : num);
  }
});
var getAngle = themeGetter({
  name: "angle",
  transform: function transform(value) {
    var num = Number(value);
    return deg(Number.isNaN(num) ? value : num);
  }
});
var getPercent = themeGetter({
  name: "percent",
  compose: getPx,
  transform: percent
});
var getTransition = themeGetter({
  name: "transition",
  key: "transitions"
});
var getTransitionProperty = themeGetter({
  name: "transitionProperty",
  key: "transitionProperties"
});
var getTimingFunction = themeGetter({
  name: "timingFunction",
  key: "timingFunctions"
});
var transition = style({
  prop: "transition",
  themeGet: getTransition
});
var transitionProperty = style({
  prop: "transitionProperty",
  themeGet: getTransitionProperty
});
var transitionDuration = style({
  prop: "transitionDuration",
  themeGet: getDuration
});
var transitionTimingFunction = style({
  prop: "transitionTimingFunction",
  themeGet: getTimingFunction
});
var transitionDelay = style({
  prop: "transitionDelay",
  themeGet: getDuration
});
var transitions$1 = compose(transition, transitionProperty, transitionDuration, transitionTimingFunction, transitionDelay);
var getAnimation = themeGetter({
  name: "animation",
  key: "animations"
});
var animation = style({
  prop: "animation",
  themeGet: getAnimation
});
var animationDuration = style({
  prop: "animationDuration",
  themeGet: getDuration
});
var animationTimingFunction = style({
  prop: "animationTimingFunction",
  themeGet: getTimingFunction
});
var animations = compose(animation, animationDuration, animationTimingFunction);
var getColor = themeGetter({
  name: "color",
  key: "colors"
});
var gradientBackgrounds = {
  "gradient-to-t": "linear-gradient(to top, var(--x-gradient-stops))",
  "gradient-to-tr": "linear-gradient(to top right, var(--x-gradient-stops))",
  "gradient-to-r": "linear-gradient(to right, var(--x-gradient-stops))",
  "gradient-to-br": "linear-gradient(to bottom right, var(--x-gradient-stops))",
  "gradient-to-b": "linear-gradient(to bottom, var(--x-gradient-stops))",
  "gradient-to-bl": "linear-gradient(to bottom left, var(--x-gradient-stops))",
  "gradient-to-l": "linear-gradient(to left, var(--x-gradient-stops))",
  "gradient-to-tl": "linear-gradient(to top left, var(--x-gradient-stops))"
};
var background = style({
  prop: "background",
  css: function css(value) {
    return {
      background: gradientBackgrounds[value] || value
    };
  }
});
var backgroundColor = style({
  prop: ["backgroundColor", "bg"],
  css: "backgroundColor",
  themeGet: getColor
});
var backgroundImage = style({
  prop: "backgroundImage",
  css: function css(value) {
    return {
      backgroundImage: gradientBackgrounds[value] || value
    };
  }
});
var backgroundSize = style({
  prop: "backgroundSize"
});
var backgroundPosition = style({
  prop: "backgroundPosition"
});
var backgroundRepeat = style({
  prop: "backgroundRepeat"
});
var backgroundAttachment = style({
  prop: "backgroundAttachment"
});
var backgroundClip = style({
  prop: "backgroundClip",
  css: ["backgroundClip", "-webkitBackgroundClip"]
});
var gradientFrom = style({
  prop: "gradientFrom",
  themeGet: getColor,
  css: function css(value) {
    return {
      "--x-gradient-from": value,
      "--x-gradient-stops": "var(--x-gradient-from), var(--x-gradient-to, transparent)"
    };
  }
});
var gradientVia = style({
  prop: "gradientVia",
  themeGet: getColor,
  css: function css(value) {
    return {
      "--x-gradient-stops": "var(--x-gradient-from), ".concat(value, ", var(--x-gradient-to, transparent)")
    };
  }
});
var gradientTo = style({
  prop: "gradientTo",
  themeGet: getColor,
  css: "--x-gradient-to"
});
var backgrounds = compose(background, backgroundColor, backgroundImage, backgroundSize, backgroundPosition, backgroundRepeat, backgroundAttachment, backgroundClip, gradientFrom, gradientVia, gradientTo);
var getBorder = themeGetter({
  name: "border",
  key: "borders",
  transform: function transform(value) {
    var num = Number(value);
    return num > 0 ? "".concat(px$1(num), " solid") : value;
  }
});
var getBorderWidth = themeGetter({
  name: "borderWidth",
  key: "borderWidths",
  compose: getPx,
  shorthand: true
});
var getBorderColor = themeGetter({
  name: "borderColor",
  compose: getColor,
  shorthand: true
});
var getBorderStyle = themeGetter({
  name: "borderStyle",
  key: "borderStyles"
});
var border = style({
  prop: "border",
  themeGet: getBorder
});
var borderTop = style({
  prop: "borderTop",
  themeGet: getBorder
});
var borderRight = style({
  prop: "borderRight",
  themeGet: getBorder
});
var borderBottom = style({
  prop: "borderBottom",
  themeGet: getBorder
});
var borderLeft = style({
  prop: "borderLeft",
  themeGet: getBorder
});
var borderColor = style({
  prop: "borderColor",
  themeGet: getBorderColor
});
var borderTopColor = style({
  prop: "borderTopColor",
  themeGet: getColor
});
var borderRightColor = style({
  prop: "borderRightColor",
  themeGet: getColor
});
var borderBottomColor = style({
  prop: "borderBottomColor",
  themeGet: getColor
});
var borderLeftColor = style({
  prop: "borderLeftColor",
  themeGet: getColor
});
var borderWidth = style({
  prop: "borderWidth",
  themeGet: getBorderWidth
});
var borderTopWidth = style({
  prop: "borderTopWidth",
  themeGet: getBorderWidth
});
var borderRightWidth = style({
  prop: "borderRightWidth",
  themeGet: getBorderWidth
});
var borderBottomWidth = style({
  prop: "borderBottomWidth",
  themeGet: getBorderWidth
});
var borderLeftWidth = style({
  prop: "borderLeftWidth",
  themeGet: getBorderWidth
});
var borderStyle = style({
  prop: "borderStyle",
  themeGet: getBorderStyle,
  cssProps: ["borderStyle", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle"]
});
var borderTopStyle = style({
  prop: "borderTopStyle",
  themeGet: getBorderStyle
});
var borderRightStyle = style({
  prop: "borderRightStyle",
  themeGet: getBorderStyle
});
var borderBottomStyle = style({
  prop: "borderBottomStyle",
  themeGet: getBorderStyle
});
var borderLeftStyle = style({
  prop: "borderLeftStyle",
  themeGet: getBorderStyle
});
var outline = style({
  prop: "outline",
  themeGet: getBorder
});
var outlineColor = style({
  prop: "outlineColor",
  themeGet: getColor
});
var outlineWidth = style({
  prop: "outlineWidth",
  themeGet: getBorderWidth
});
var outlineStyle = style({
  prop: "outlineStyle",
  themeGet: getBorderStyle
});
var outlineOffset = style({
  prop: "outlineOffset",
  themeGet: getBorderWidth
});
var getRadius = themeGetter({
  name: "radius",
  key: "radii",
  compose: getPx,
  shorthand: true
});
var borderRadius = style({
  prop: "borderRadius",
  themeGet: getRadius,
  cssProps: ["borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"]
});
var divideSelector = "& > :not([hidden]) ~ :not([hidden])";
var divideY = style({
  prop: "divideY",
  themeGet: getBorderWidth,
  css: function css(value) {
    var v = value === true ? 1 : value;
    return _defineProperty({}, divideSelector, {
      "--x-divide-y-reverse": 0,
      borderTopWidth: "calc(".concat(v, " * calc(1 - var(--x-divide-y-reverse)))"),
      borderBottomWidth: "calc(".concat(v, " * var(--x-divide-y-reverse))")
    });
  }
});
var divideX = style({
  prop: "divideX",
  themeGet: getBorderWidth,
  css: function css(value) {
    var v = value === true ? 1 : value;
    return _defineProperty({}, divideSelector, {
      "--x-divide-x-reverse": 0,
      borderRightWidth: "calc(".concat(v, " * var(--x-divide-x-reverse))"),
      borderLeftWidth: "calc(".concat(v, " * calc(1 - var(--x-divide-x-reverse)))")
    });
  }
});
var divideXReverse = style({
  prop: "divideXReverse",
  css: function css() {
    return _defineProperty({}, divideSelector, {
      "--x-divide-x-reverse": "1"
    });
  }
});
var divideYReverse = style({
  prop: "divideYReverse",
  css: function css() {
    return _defineProperty({}, divideSelector, {
      "--x-divide-y-reverse": "1"
    });
  }
});
var divideColor = style({
  prop: "divideColor",
  themeGet: getColor,
  css: function css(value) {
    return _defineProperty({}, divideSelector, {
      borderColor: value
    });
  }
});
var divideStyle = style({
  prop: "divideStyle",
  themeGet: getBorderStyle,
  css: function css(value) {
    return _defineProperty({}, divideSelector, {
      borderStyle: value
    });
  }
});
var getRingWidth = themeGetter({
  name: "ringWidth",
  key: "ringWidths",
  compose: getPx
});
var ring = style({
  prop: "ring",
  themeGet: getRingWidth,
  css: function css(value) {
    return {
      "--x-ring-shadow": "var(--x-ring-inset, /*!*/ /*!*/) 0 0 0 ".concat(value, " var(--x-ring-color)"),
      boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow, 0 0 #0000)"
    };
  }
});
var ringInset = style({
  prop: "ringInset",
  css: function css() {
    return {
      "--x-ring-inset": "inset"
    };
  }
});
var ringColor = style({
  prop: "ringColor",
  themeGet: getColor,
  css: function css(value) {
    return {
      "--x-ring-color": value
    };
  }
});
var borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderWidth, borderTopWidth, borderRightWidth, borderBottomWidth, borderLeftWidth, borderStyle, borderTopStyle, borderRightStyle, borderBottomStyle, borderLeftStyle, borderRadius, outline, outlineColor, outlineWidth, outlineStyle, outlineOffset, divideX, divideY, divideXReverse, divideYReverse, divideColor, divideStyle, ring, ringInset, ringColor);
var getShadow = themeGetter({
  name: "shadow",
  key: "shadows",
  multiple: true
});
var opacity = style({
  prop: "opacity"
});
var boxShadow = style({
  prop: "boxShadow",
  themeGet: getShadow,
  css: function css(value) {
    return {
      "--x-shadow": value,
      boxShadow: "var(--x-ring-shadow, 0 0 #0000), var(--x-shadow)"
    };
  }
});
var textShadow = style({
  prop: "textShadow",
  themeGet: getShadow
});
var effects = compose(opacity, boxShadow, textShadow);
var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$4 = function __defNormalProp$4(obj2, key, value) {
  return key in obj2 ? __defProp$4(obj2, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj2[key] = value;
};

var __spreadValues$4 = function __spreadValues$4(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$4) {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropSymbols$4(b)),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var prop = _step3.value;
        if (__propIsEnum$4.call(b, prop)) __defNormalProp$4(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return a;
};

var row = style({
  prop: "row",
  css: function css() {
    return {
      boxSizing: "border-box",
      flexGrow: 1,
      flexWrap: "wrap",
      display: "flex"
    };
  }
});

var getColStyle = function getColStyle(props, size) {
  if (!is(size)) return null;

  if (size === true) {
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };
  }

  if (size === "auto") {
    return {
      flex: "0 0 auto",
      maxWidth: "none",
      width: "auto"
    };
  }

  var sizeWidth = getPercent(size)(props);
  return {
    flex: "0 0 ".concat(sizeWidth),
    maxWidth: sizeWidth
  };
};

var col = createStyleGenerator({
  getStyle: function getStyle(props) {
    var value = props.col;
    var common = {
      boxSizing: "border-box",
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    };

    if (obj(value)) {
      var breakpointsStyle = reduceVariants(props, value, function (v) {
        return getColStyle(props, v);
      });
      return __spreadValues$4(__spreadValues$4({}, common), breakpointsStyle);
    }

    return __spreadValues$4(__spreadValues$4({}, common), getColStyle(props, value));
  },
  props: ["col"]
});
var flexboxGrids = compose(row, col);
var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$3 = function __defNormalProp$3(obj2, key, value) {
  return key in obj2 ? __defProp$3(obj2, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj2[key] = value;
};

var __spreadValues$3 = function __spreadValues$3(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$3) {
    var _iterator4 = _createForOfIteratorHelper(__getOwnPropSymbols$3(b)),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var prop = _step4.value;
        if (__propIsEnum$3.call(b, prop)) __defNormalProp$3(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  return a;
};

var display = style({
  prop: "display"
});
var float = style({
  prop: "float"
});
var boxSizing = style({
  prop: "boxSizing"
});
var container = createStyleGenerator({
  getStyle: function getStyle(props) {
    if (!props.container) return null;
    var breakpoints = getScreens(props);
    var styles = reduceVariants(props, breakpoints, function (v) {
      return v !== 0 ? {
        maxWidth: v
      } : {};
    });

    if (obj(props.container)) {
      styles = reduceVariants(props, props.container, function () {
        return styles;
      });
    }

    return __spreadValues$3({
      width: "100%"
    }, styles);
  },
  props: ["container"]
});
var overflow = style({
  prop: "overflow"
});
var overflowX = style({
  prop: "overflowX"
});
var overflowY = style({
  prop: "overflowY"
});
var getZIndex = themeGetter({
  name: "zIndex",
  key: "zIndices"
});
var zIndex = style({
  prop: "zIndex",
  themeGet: getZIndex
});
var position = style({
  prop: "position"
});
var getInset = themeGetter({
  name: "inset",
  key: "inset",
  compose: getPx,
  transform: transformNegative
});
var top = style({
  prop: "top",
  themeGet: getInset
});
var right = style({
  prop: "right",
  themeGet: getInset
});
var bottom = style({
  prop: "bottom",
  themeGet: getInset
});
var left = style({
  prop: "left",
  themeGet: getInset
});
var visibility = style({
  prop: "visibility"
});
var overscrollBehavior = style({
  prop: "overscrollBehavior"
});
var objectFit = style({
  prop: "objectFit"
});
var layout = compose(boxSizing, display, float, container, overflow, overflowX, overflowY, position, zIndex, top, right, bottom, left, visibility, overscrollBehavior, objectFit);
var alignItems = style({
  prop: "alignItems"
});
var alignContent = style({
  prop: "alignContent"
});
var justifyContent = style({
  prop: "justifyContent"
});
var justifyItems = style({
  prop: "justifyItems"
});
var flexWrap = style({
  prop: "flexWrap"
});
var flexGrow = style({
  prop: "flexGrow"
});
var flexShrink = style({
  prop: "flexShrink"
});
var flexBasis = style({
  prop: "flexBasis",
  themeGet: getPercent
});
var flexDirection = style({
  prop: "flexDirection"
});
var flex = style({
  prop: "flex"
});
var justifySelf = style({
  prop: "justifySelf"
});
var alignSelf = style({
  prop: "alignSelf"
});
var order = style({
  prop: "order"
});
var flexboxes = compose(display, alignItems, alignContent, justifyContent, justifyItems, flexWrap, flexBasis, flexShrink, flexGrow, flexDirection, flex, justifySelf, alignSelf, order);
var getSpace = themeGetter({
  name: "space",
  key: "space",
  compose: getPx,
  shorthand: true,
  transform: transformNegative
});
var margin = style({
  prop: ["margin", "m"],
  themeGet: getSpace,
  css: "margin"
});
var marginTop = style({
  prop: ["marginTop", "mt"],
  themeGet: getSpace,
  css: "marginTop"
});
var marginRight = style({
  prop: ["marginRight", "mr"],
  themeGet: getSpace,
  css: "marginRight"
});
var marginBottom = style({
  prop: ["marginBottom", "mb"],
  themeGet: getSpace,
  css: "marginBottom"
});
var marginLeft = style({
  prop: ["marginLeft", "ml"],
  themeGet: getSpace,
  css: "marginLeft"
});
var mx = style({
  prop: "mx",
  themeGet: getSpace,
  css: ["marginRight", "marginLeft"]
});
var my = style({
  prop: "my",
  themeGet: getSpace,
  css: ["marginTop", "marginBottom"]
});
var padding = style({
  prop: ["padding", "p"],
  themeGet: getSpace,
  css: "padding"
});
var paddingTop = style({
  prop: ["paddingTop", "pt"],
  themeGet: getSpace,
  css: "paddingTop"
});
var paddingRight = style({
  prop: ["paddingRight", "pr"],
  themeGet: getSpace,
  css: "paddingRight"
});
var paddingBottom = style({
  prop: ["paddingBottom", "pb"],
  themeGet: getSpace,
  css: "paddingBottom"
});
var paddingLeft = style({
  prop: ["paddingLeft", "pl"],
  themeGet: getSpace,
  css: "paddingLeft"
});
var px = style({
  prop: "px",
  themeGet: getSpace,
  css: ["paddingRight", "paddingLeft"]
});
var py = style({
  prop: "py",
  themeGet: getSpace,
  css: ["paddingTop", "paddingBottom"]
});
var spaceY = style({
  prop: "spaceY",
  themeGet: getSpace,
  css: function css(value) {
    return {
      "& > :not([hidden]) ~ :not([hidden])": {
        "--x-space-y-reverse": 0,
        marginTop: "calc(".concat(value, " * calc(1 - var(--x-space-y-reverse)))"),
        marginBottom: "calc(".concat(value, " * var(--x-space-y-reverse))")
      }
    };
  }
});
var spaceX = style({
  prop: "spaceX",
  themeGet: getSpace,
  css: function css(value) {
    return {
      "& > :not([hidden]) ~ :not([hidden])": {
        "--x-space-x-reverse": 0,
        marginRight: "calc(".concat(value, " * var(--x-space-x-reverse))"),
        marginLeft: "calc(".concat(value, " * calc(1 - var(--x-space-x-reverse)))")
      }
    };
  }
});
var spaceXReverse = style({
  prop: "spaceXReverse",
  css: function css() {
    return {
      "& > :not([hidden]) ~ :not([hidden])": {
        "--x-space-x-reverse": "1"
      }
    };
  }
});
var spaceYReverse = style({
  prop: "spaceYReverse",
  css: function css() {
    return {
      "& > :not([hidden]) ~ :not([hidden])": {
        "--x-space-y-reverse": "1"
      }
    };
  }
});
var space$1 = compose(margin, marginTop, marginRight, marginBottom, marginLeft, mx, my, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, px, py, spaceX, spaceY, spaceXReverse, spaceYReverse);
var gap = style({
  prop: "gap",
  themeGet: getSpace
});
var columnGap = style({
  prop: "columnGap",
  themeGet: getSpace
});
var rowGap = style({
  prop: "rowGap",
  themeGet: getSpace
});
var gridColumn = style({
  prop: "gridColumn"
});
var gridRow = style({
  prop: "gridRow"
});
var gridAutoFlow = style({
  prop: "gridAutoFlow"
});
var gridAutoColumns = style({
  prop: "gridAutoColumns"
});
var gridAutoRows = style({
  prop: "gridAutoRows"
});
var gridTemplateColumns = style({
  prop: "gridTemplateColumns",
  key: "gridTemplateColumns"
});
var gridTemplateRows = style({
  prop: "gridTemplateRows",
  key: "gridTemplateRows"
});
var gridTemplateAreas = style({
  prop: "gridTemplateAreas"
});
var gridArea = style({
  prop: "gridArea"
});
var grids = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var appearance = style({
  prop: "appearance"
});
var cursor = style({
  prop: "cursor"
});
var pointerEvents = style({
  prop: "pointerEvents"
});
var resize = style({
  prop: "resize"
});
var userSelect = style({
  prop: "userSelect"
});
var interactivity = compose(appearance, cursor, pointerEvents, resize, userSelect);
var getSize = themeGetter({
  name: "size",
  key: "sizes",
  compose: getPercent
});
var width = style({
  prop: "w",
  themeGet: getSize,
  css: "width"
});
var height = style({
  prop: "h",
  themeGet: getSize,
  css: "height"
});
var maxWidth = style({
  prop: ["maxWidth", "maxW"],
  themeGet: getSize,
  css: "maxWidth"
});
var maxHeight = style({
  prop: ["maxHeight", "maxH"],
  themeGet: getSize,
  css: "maxHeight"
});
var minWidth = style({
  prop: ["minWidth", "minW"],
  themeGet: getSize,
  css: "minWidth"
});
var minHeight = style({
  prop: ["minHeight", "minH"],
  themeGet: getSize,
  css: "minHeight"
});
var maskSize = style({
  prop: "maskSize",
  themeGet: themeGetter({
    name: "size",
    key: "sizes",
    compose: getPercent,
    multiple: true,
    shorthand: true
  })
});
var sizing = compose(width, height, maxWidth, maxHeight, minWidth, minHeight, maskSize);
var fill = style({
  prop: "fill",
  themeGet: getColor
});
var stroke = style({
  prop: "stroke",
  themeGet: getColor
});
var svg = compose(fill, stroke);
var borderCollapse = style({
  prop: "borderCollapse"
});
var tableLayout = style({
  prop: "tableLayout"
});
var tables = compose(borderCollapse, tableLayout);
var getTransform = themeGetter({
  name: "transform",
  key: "transforms"
});
var transform = style({
  prop: "transform",
  themeGet: getTransform,
  css: function css(value) {
    if (value === true) {
      return {
        "--x-translate-x": 0,
        "--x-translate-y": 0,
        "--x-rotate": 0,
        "--x-skew-x": 0,
        "--x-skew-y": 0,
        "--x-scale-x": "1",
        "--x-scale-y": "1",
        transform: "translate3d(var(--x-translate-x), var(--x-translate-y), 0) rotate(var(--x-rotate)) skewX(var(--x-skew-x)) skewY(var(--x-skew-y)) scaleX(var(--x-scale-x)) scaleY(var(--x-scale-y))"
      };
    }

    return {
      transform: value
    };
  }
});
var transformOrigin = style({
  prop: "transformOrigin"
});
var translateX = style({
  prop: "translateX",
  themeGet: getSpace,
  css: "--x-translate-x"
});
var translateY = style({
  prop: "translateY",
  themeGet: getSpace,
  css: "--x-translate-y"
});
var rotate = style({
  prop: "rotate",
  themeGet: getAngle,
  css: "--x-rotate"
});
var skewX = style({
  prop: "skewX",
  themeGet: getAngle,
  css: "--x-skew-x"
});
var skewY = style({
  prop: "skewY",
  themeGet: getAngle,
  css: "--x-skew-y"
});
var scale = style({
  prop: "scale",
  transform: function transform(v) {
    return String(v);
  },
  css: ["--x-scale-x", "--x-scale-y"]
});
var scaleX = style({
  prop: "scaleX",
  transform: function transform(v) {
    return String(v);
  },
  css: "--x-scale-x"
});
var scaleY = style({
  prop: "scaleY",
  transform: function transform(v) {
    return String(v);
  },
  css: "--x-scale-y"
});
var transforms = compose(transform, transformOrigin, translateX, translateY, rotate, skewX, skewY, scale, scaleX, scaleY);
var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$2 = function __defNormalProp$2(obj, key, value) {
  return key in obj ? __defProp$2(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues$2 = function __spreadValues$2(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$2) {
    var _iterator5 = _createForOfIteratorHelper(__getOwnPropSymbols$2(b)),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var prop = _step5.value;
        if (__propIsEnum$2.call(b, prop)) __defNormalProp$2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return a;
};

var __spreadProps$1 = function __spreadProps$1(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};

var getFont = themeGetter({
  name: "font",
  key: "fonts"
});
var getLineHeight = themeGetter({
  name: "lineHeight",
  key: "lineHeights",
  transform: function transform(value, _ref15) {
    var props = _ref15.props;

    var _a, _b, _c;

    var rootFontSize = (_c = (_b = (_a = props == null ? void 0 : props.theme) == null ? void 0 : _a.settings) == null ? void 0 : _b.rootFontSize) != null ? _c : void 0;
    return rpx(value, {
      rootFontSize: rootFontSize
    });
  }
});
var getFontWeight = themeGetter({
  name: "fontWeight",
  key: "fontWeights"
});
var getLetterSpacing = themeGetter({
  name: "letterSpacing",
  key: "letterSpacings",
  compose: getPx
});
var getFontSize = themeGetter({
  name: "fontSize",
  key: "fontSizes",
  compose: getPx
});
var fontFamily = style({
  prop: "fontFamily",
  themeGet: getFont
});
var fontSize = style({
  prop: "fontSize",
  themeGet: getFontSize
});
var lineHeight = style({
  prop: "lineHeight",
  themeGet: getLineHeight
});
var fontWeight = style({
  prop: "fontWeight",
  themeGet: getFontWeight
});
var fontStyle = style({
  prop: "fontStyle"
});
var letterSpacing = style({
  prop: "letterSpacing",
  themeGet: getLetterSpacing
});
var color = style({
  prop: "color",
  themeGet: getColor
});
var textTransform = style({
  prop: "textTransform"
});
var textDecoration = style({
  prop: "textDecoration"
});
var textAlign = style({
  prop: "textAlign"
});
var verticalAlign = style({
  prop: "verticalAlign"
});
var whiteSpace = style({
  prop: "whiteSpace"
});
var textOverflow = style({
  prop: "textOverflow"
});
var listStyleType = style({
  prop: "listStyleType"
});
var listStylePosition = style({
  prop: "listStylePosition"
});
var all = compose(space$1, fontFamily, fontSize, fontStyle, lineHeight, fontWeight, textAlign, letterSpacing, color, textTransform, textDecoration, verticalAlign, whiteSpace, textOverflow, listStyleType, listStylePosition);
var text = style({
  prop: "text",
  key: "texts",
  css: function css(value) {
    return function (_ref16) {
      var theme = _ref16.theme;
      return all(__spreadProps$1(__spreadValues$2({}, value), {
        theme: theme
      }));
    };
  }
});
var typography = compose(all, text);
var system = compose(animations, backgrounds, borders, effects, flexboxGrids, flexboxes, grids, interactivity, layout, sizing, space$1, svg, tables, transforms, transitions$1, typography);

var th = function th(path, defaultValue) {
  return function (props) {
    var value = getThemeValue(props, path);
    if (is(value)) return value;
    if (is(defaultValue)) return defaultValue;
    return path;
  };
};

[getAngle, getAnimation, getBorder, getBorderColor, getBorderStyle, getBorderWidth, getColor, getDuration, getFont, getFontSize, getFontWeight, getInset, getLetterSpacing, getLineHeight, getPercent, getPx, getRadius, getRingWidth, getShadow, getSize, getSpace, getTimingFunction, getTransform, getTransition, getTransitionProperty, getZIndex].forEach(function (themeGetter) {
  th[themeGetter.meta.name] = themeGetter;
});

var up = function up(key, rules) {
  return function (props) {
    var screens = getScreens(props);
    var value = getBreakpointMin(screens, key);
    if (value === null) return rules;
    return ["".concat(mediaMinWidth(value), " {"), rules, "}"];
  };
};

var down = function down(key, rules) {
  return function (props) {
    var screens = getScreens(props);
    var value = getBreakpointMax(screens, key);
    if (value === null) return null;
    return ["".concat(mediaMaxWidth(value), " {"), rules, "}"];
  };
};

var between = function between(lower, upper, rules) {
  return function (props) {
    var screens = getScreens(props);
    var min = getBreakpointMin(screens, lower);
    var max = getBreakpointMax(screens, upper);
    if (max === null) return up(lower, rules)(props);
    if (min === null) return down(upper, rules)(props);
    return ["".concat(mediaBetweenWidth(min, max), " {"), rules, "}"];
  };
};

var breakpoints = function breakpoints(values) {
  return function (props) {
    var allRules = [];
    var keys = Object.keys(values);
    var keysLength = keys.length;

    for (var i = 0; i < keysLength; i++) {
      var key = keys[i];
      var rules = values[key];
      var result = up(key, rules)(props);

      if (Array.isArray(result)) {
        result.forEach(function (v) {
          return allRules.push(v);
        });
      } else {
        allRules.push(result);
      }
    }

    return allRules;
  };
};

var rpxTransformers = {
  px: function px(value) {
    return remPx(rpx(value));
  },
  border: function border(value) {
    return num(value) && value > 0 ? "".concat(remPx(value), " solid") : value;
  }
};
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;

var __defNormalProp$1 = function __defNormalProp$1(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues$1 = function __spreadValues$1(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols$1) {
    var _iterator6 = _createForOfIteratorHelper(__getOwnPropSymbols$1(b)),
        _step6;

    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var prop = _step6.value;
        if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
  }

  return a;
};

var defaultAlphaVariants = [0, 5, 10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 95, 100];

var generateHexAlphaVariants = function generateHexAlphaVariants(colors) {
  var variants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultAlphaVariants;

  var transform = function transform(value, variant) {
    return "".concat(value).concat(Math.round(variant / 100 * 255).toString(16).padStart(2, "0"));
  };

  var alphaColors = Object.keys(colors).reduce(function (obj, key) {
    variants.forEach(function (variant) {
      var value = colors[key];
      var variantKey = "".concat(key, "-a").concat(variant);
      obj[variantKey] = string(value) ? transform(value, variant) : generateHexAlphaVariants(value, variants);
    });
    return obj;
  }, {});
  return __spreadValues$1(__spreadValues$1({}, colors), alphaColors);
};

var defaultTones = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

var aliasColor = function aliasColor(alias, color) {
  var tones = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultTones;
  var variants = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultAlphaVariants;
  return tones.reduce(function (obj, tone) {
    obj["".concat(alias, "-").concat(tone)] = th.color("".concat(color, "-").concat(tone));
    variants.forEach(function (i) {
      obj["".concat(alias, "-").concat(tone, "-a").concat(i)] = th.color("".concat(color, "-").concat(tone, "-a").concat(i));
    });
    return obj;
  }, {});
};

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator7 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var prop = _step7.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var space = {
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  11: "2.75rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
var timingFunctions = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
};
var transitionProperties = {
  default: ["background-color", "border-color", "color", "fill", "stroke", "opacity", "box-shadow", "transform"],
  colors: ["background-color", "border-color", "color", "fill", "stroke"],
  opacity: ["opacity"],
  shadow: ["box-shadow"],
  transform: ["transform"]
};
var transitions = Object.keys(transitionProperties).reduce(function (obj, key) {
  obj[key] = transitionProperties[key].map(function (property) {
    return "".concat(property, " ").concat(timingFunctions["ease-in-out"], " 150ms");
  }).join(",");
  return obj;
}, {});
var colors = {
  black: "#000000",
  white: "#ffffff",
  "blue-gray-50": "#f8fafc",
  "blue-gray-100": "#f1f5f9",
  "blue-gray-200": "#e2e8f0",
  "blue-gray-300": "#cbd5e1",
  "blue-gray-400": "#94a3b8",
  "blue-gray-500": "#64748b",
  "blue-gray-600": "#475569",
  "blue-gray-700": "#334155",
  "blue-gray-800": "#1e293b",
  "blue-gray-900": "#0f172a",
  "cool-gray-50": "#f9fafb",
  "cool-gray-100": "#f3f4f6",
  "cool-gray-200": "#e5e7eb",
  "cool-gray-300": "#d1d5db",
  "cool-gray-400": "#9ca3af",
  "cool-gray-500": "#6b7280",
  "cool-gray-600": "#4b5563",
  "cool-gray-700": "#374151",
  "cool-gray-800": "#1f2937",
  "cool-gray-900": "#111827",
  "gray-50": "#fafafa",
  "gray-100": "#f4f4f5",
  "gray-200": "#e4e4e7",
  "gray-300": "#d4d4d8",
  "gray-400": "#a1a1aa",
  "gray-500": "#71717a",
  "gray-600": "#52525b",
  "gray-700": "#3f3f46",
  "gray-800": "#27272a",
  "gray-900": "#18181b",
  "true-gray-50": "#fafafa",
  "true-gray-100": "#f5f5f5",
  "true-gray-200": "#e5e5e5",
  "true-gray-300": "#d4d4d4",
  "true-gray-400": "#a3a3a3",
  "true-gray-500": "#737373",
  "true-gray-600": "#525252",
  "true-gray-700": "#404040",
  "true-gray-800": "#262626",
  "true-gray-900": "#171717",
  "warm-gray-50": "#fafaf9",
  "warm-gray-100": "#f5f5f4",
  "warm-gray-200": "#e7e5e4",
  "warm-gray-300": "#d6d3d1",
  "warm-gray-400": "#a8a29e",
  "warm-gray-500": "#78716c",
  "warm-gray-600": "#57534e",
  "warm-gray-700": "#44403c",
  "warm-gray-800": "#292524",
  "warm-gray-900": "#1c1917",
  "red-50": "#fef2f2",
  "red-100": "#fee2e2",
  "red-200": "#fecaca",
  "red-300": "#fca5a5",
  "red-400": "#f87171",
  "red-500": "#ef4444",
  "red-600": "#dc2626",
  "red-700": "#b91c1c",
  "red-800": "#991b1b",
  "red-900": "#7f1d1d",
  "orange-50": "#fff7ed",
  "orange-100": "#ffedd5",
  "orange-200": "#fed7aa",
  "orange-300": "#fdba74",
  "orange-400": "#fb923c",
  "orange-500": "#f97316",
  "orange-600": "#ea580c",
  "orange-700": "#c2410c",
  "orange-800": "#9a3412",
  "orange-900": "#7c2d12",
  "amber-50": "#fffbeb",
  "amber-100": "#fef3c7",
  "amber-200": "#fde68a",
  "amber-300": "#fcd34d",
  "amber-400": "#fbbf24",
  "amber-500": "#f59e0b",
  "amber-600": "#d97706",
  "amber-700": "#b45309",
  "amber-800": "#92400e",
  "amber-900": "#78350f",
  "yellow-50": "#fefce8",
  "yellow-100": "#fef9c3",
  "yellow-200": "#fef08a",
  "yellow-300": "#fde047",
  "yellow-400": "#facc15",
  "yellow-500": "#eab308",
  "yellow-600": "#ca8a04",
  "yellow-700": "#a16207",
  "yellow-800": "#854d0e",
  "yellow-900": "#713f12",
  "lime-50": "#f7fee7",
  "lime-100": "#ecfccb",
  "lime-200": "#d9f99d",
  "lime-300": "#bef264",
  "lime-400": "#a3e635",
  "lime-500": "#84cc16",
  "lime-600": "#65a30d",
  "lime-700": "#4d7c0f",
  "lime-800": "#3f6212",
  "lime-900": "#365314",
  "green-50": "#f0fdf4",
  "green-100": "#dcfce7",
  "green-200": "#bbf7d0",
  "green-300": "#86efac",
  "green-400": "#4ade80",
  "green-500": "#22c55e",
  "green-600": "#16a34a",
  "green-700": "#15803d",
  "green-800": "#166534",
  "green-900": "#14532d",
  "emerald-50": "#ecfdf5",
  "emerald-100": "#d1fae5",
  "emerald-200": "#a7f3d0",
  "emerald-300": "#6ee7b7",
  "emerald-400": "#34d399",
  "emerald-500": "#10b981",
  "emerald-600": "#059669",
  "emerald-700": "#047857",
  "emerald-800": "#065f46",
  "emerald-900": "#064e3b",
  "teal-50": "#f0fdfa",
  "teal-100": "#ccfbf1",
  "teal-200": "#99f6e4",
  "teal-300": "#5eead4",
  "teal-400": "#2dd4bf",
  "teal-500": "#14b8a6",
  "teal-600": "#0d9488",
  "teal-700": "#0f766e",
  "teal-800": "#115e59",
  "teal-900": "#134e4a",
  "cyan-50": "#ecfeff",
  "cyan-100": "#cffafe",
  "cyan-200": "#a5f3fc",
  "cyan-300": "#67e8f9",
  "cyan-400": "#22d3ee",
  "cyan-500": "#06b6d4",
  "cyan-600": "#0891b2",
  "cyan-700": "#0e7490",
  "cyan-800": "#155e75",
  "cyan-900": "#164e63",
  "light-blue-50": "#f0f9ff",
  "light-blue-100": "#e0f2fe",
  "light-blue-200": "#bae6fd",
  "light-blue-300": "#7dd3fc",
  "light-blue-400": "#38bdf8",
  "light-blue-500": "#0ea5e9",
  "light-blue-600": "#0284c7",
  "light-blue-700": "#0369a1",
  "light-blue-800": "#075985",
  "light-blue-900": "#0c4a6e",
  "blue-50": "#eff6ff",
  "blue-100": "#dbeafe",
  "blue-200": "#bfdbfe",
  "blue-300": "#93c5fd",
  "blue-400": "#60a5fa",
  "blue-500": "#3b82f6",
  "blue-600": "#2563eb",
  "blue-700": "#1d4ed8",
  "blue-800": "#1e40af",
  "blue-900": "#1e3a8a",
  "indigo-50": "#eef2ff",
  "indigo-100": "#e0e7ff",
  "indigo-200": "#c7d2fe",
  "indigo-300": "#a5b4fc",
  "indigo-400": "#818cf8",
  "indigo-500": "#6366f1",
  "indigo-600": "#4f46e5",
  "indigo-700": "#4338ca",
  "indigo-800": "#3730a3",
  "indigo-900": "#312e81",
  "violet-50": "#f5f3ff",
  "violet-100": "#ede9fe",
  "violet-200": "#ddd6fe",
  "violet-300": "#c4b5fd",
  "violet-400": "#a78bfa",
  "violet-500": "#8b5cf6",
  "violet-600": "#7c3aed",
  "violet-700": "#6d28d9",
  "violet-800": "#5b21b6",
  "violet-900": "#4c1d95",
  "purple-50": "#faf5ff",
  "purple-100": "#f3e8ff",
  "purple-200": "#e9d5ff",
  "purple-300": "#d8b4fe",
  "purple-400": "#c084fc",
  "purple-500": "#a855f7",
  "purple-600": "#9333ea",
  "purple-700": "#7e22ce",
  "purple-800": "#6b21a8",
  "purple-900": "#581c87",
  "fuchsia-50": "#fdf4ff",
  "fuchsia-100": "#fae8ff",
  "fuchsia-200": "#f5d0fe",
  "fuchsia-300": "#f0abfc",
  "fuchsia-400": "#e879f9",
  "fuchsia-500": "#d946ef",
  "fuchsia-600": "#c026d3",
  "fuchsia-700": "#a21caf",
  "fuchsia-800": "#86198f",
  "fuchsia-900": "#701a75",
  "pink-50": "#fdf2f8",
  "pink-100": "#fce7f3",
  "pink-200": "#fbcfe8",
  "pink-300": "#f9a8d4",
  "pink-400": "#f472b6",
  "pink-500": "#ec4899",
  "pink-600": "#db2777",
  "pink-700": "#be185d",
  "pink-800": "#9d174d",
  "pink-900": "#831843",
  "rose-50": "#fff1f2",
  "rose-100": "#ffe4e6",
  "rose-200": "#fecdd3",
  "rose-300": "#fda4af",
  "rose-400": "#fb7185",
  "rose-500": "#f43f5e",
  "rose-600": "#e11d48",
  "rose-700": "#be123c",
  "rose-800": "#9f1239",
  "rose-900": "#881337"
};
var fontSizes = {
  xs: "0.75rem",
  sm: "0.875rem",
  default: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
  "5xl": "3rem",
  "6xl": "3.75rem",
  "7xl": "4.5rem",
  "8xl": "6rem",
  "9xl": "8rem"
};
var texts = Object.keys(fontSizes).reduce(function (texts2, key) {
  texts2[key] = {
    fontSize: key,
    lineHeight: key
  };
  return texts2;
}, {});
var defaultTheme = {
  colors: generateHexAlphaVariants(colors),
  space: space,
  screens: {
    _: 0,
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1536
  },
  durations: {
    instant: "100ms",
    "fast-in": "250ms",
    "fast-out": "200ms",
    "slow-in": "300ms",
    "slow-out": "250ms"
  },
  sizes: __spreadProps(__spreadValues({}, space), {
    0.5: void 0,
    1: void 0,
    "0.5s": space[0.5],
    "1s": space[1],
    full: "100%",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem"
  }),
  radii: {
    none: "0",
    sm: "0.125rem",
    default: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
  },
  shadows: {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    default: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    inner: "inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.5)"
  },
  fontSizes: fontSizes,
  fontWeights: {
    hairline: "100",
    thin: "200",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900"
  },
  fonts: {
    mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
    serif: "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    sans: "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\""
  },
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0em",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    none: 1,
    tight: 1.25,
    snug: 1.375,
    normal: 1.5,
    relaxed: 1.625,
    loose: 2,
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    xs: "1rem",
    sm: "1.25rem",
    default: "1.5rem",
    lg: "1.75rem",
    xl: "1.75rem",
    "2xl": "2rem",
    "3xl": "2.25rem",
    "4xl": "2.5rem",
    "5xl": 1,
    "6xl": 1,
    "7xl": 1,
    "8xl": 1,
    "9xl": 1
  },
  gridTemplateColumns: {
    1: "repeat(1, minmax(0, 1fr))",
    2: "repeat(2, minmax(0, 1fr))",
    3: "repeat(3, minmax(0, 1fr))",
    4: "repeat(4, minmax(0, 1fr))",
    5: "repeat(5, minmax(0, 1fr))",
    6: "repeat(6, minmax(0, 1fr))",
    7: "repeat(7, minmax(0, 1fr))",
    8: "repeat(8, minmax(0, 1fr))",
    9: "repeat(9, minmax(0, 1fr))",
    10: "repeat(10, minmax(0, 1fr))",
    11: "repeat(11, minmax(0, 1fr))",
    12: "repeat(12, minmax(0, 1fr))"
  },
  gridTemplateRows: {
    1: "repeat(1, minmax(0, 1fr))",
    2: "repeat(2, minmax(0, 1fr))",
    3: "repeat(3, minmax(0, 1fr))",
    4: "repeat(4, minmax(0, 1fr))",
    5: "repeat(5, minmax(0, 1fr))",
    6: "repeat(6, minmax(0, 1fr))"
  },
  borderWidths: {
    default: 1
  },
  ringWidths: {
    default: 3
  },
  borders: {
    default: "1px solid transparent"
  },
  texts: texts,
  transitions: transitions,
  transitionProperties: transitionProperties,
  timingFunctions: timingFunctions,
  animations: {
    spin: "x-spin 1s linear infinite",
    ping: "x-ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
    pulse: "x-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
    bounce: "x-bounce 1s infinite"
  },
  states: {
    _: null,
    motionSafe: "@media (prefers-reduced-motion: no-preference)",
    motionReduce: "@media (prefers-reduced-motion: reduce)",
    first: "&:first-child",
    last: "&:last-child",
    odd: "&:odd",
    even: "&:even",
    visited: "&:visited",
    checked: "&:checked",
    focusWithin: "&:focus-within",
    hover: "&:hover",
    focus: "&:focus",
    focusVisible: "&:focus-visible",
    active: "&:active",
    disabled: "&:disabled, &[aria-disabled=true]",
    placeholder: "&::placeholder"
  },
  xstyled: {
    cache: true
  }
};

var getPreflightStyles = function getPreflightStyles(theme) {
  return "\n/*! modern-normalize v1.0.0 | MIT License | https://github.com/sindresorhus/modern-normalize */\n*,::after,::before{box-sizing:border-box}:root{-moz-tab-size:4;tab-size:4}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}body{font-family:system-ui,-apple-system,'Segoe UI',Roboto,Helvetica,Arial,sans-serif,'Apple Color Emoji','Segoe UI Emoji'}hr{height:0;color:inherit}abbr[title]{text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Consolas,'Liberation Mono',Menlo,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button}::-moz-focus-inner{border-style:none;padding:0}:-moz-focusring{outline:1px dotted ButtonText}:-moz-ui-invalid{box-shadow:none}legend{padding:0}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}\n\n/* Role button pointer */\n[role=button], button {\n  cursor: pointer;\n}\n\n/* Remove default margins */\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\n/* Remove headings styles */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/* Unstyle lists */\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Image are block-level */\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  vertical-align: middle;\n}\n\n/* Reset border styles */\n*,\n::before,\n::after {\n  border-width: 0;\n  border-style: solid;\n  border-color: ".concat(th.color("default-border-color", "currentColor")({
    theme: theme
  }), ";\n}\n\n* {\n  --x-ring-color: ").concat(th.color("default-ring-color", "rgba(59,130,246,0.5)")({
    theme: theme
  }), ";\n}\n\n/* Default outline on buttons */\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\n// Animations\n@keyframes x-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes x-ping {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n@keyframes x-pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .5;\n  }\n}\n\n@keyframes x-bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animationTimingFunction: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: translateY(0);\n    animationTimingFunction: cubic-bezier(0, 0, 0.2, 1);\n  }\n}\n");
};

export { aliasColor, alignContent, alignItems, alignSelf, animation, animationDuration, animationTimingFunction, animations, appearance, background, backgroundAttachment, backgroundClip, backgroundColor, backgroundImage, backgroundPosition, backgroundRepeat, backgroundSize, backgrounds, between, border, borderBottom, borderBottomColor, borderBottomStyle, borderBottomWidth, borderCollapse, borderColor, borderLeft, borderLeftColor, borderLeftStyle, borderLeftWidth, borderRadius, borderRight, borderRightColor, borderRightStyle, borderRightWidth, borderStyle, borderTop, borderTopColor, borderTopStyle, borderTopWidth, borderWidth, borders, bottom, boxShadow, boxSizing, breakpoints, col, color, columnGap, compose, container, createStyleGenerator, cursor, defaultTheme, display, divideColor, divideStyle, divideX, divideXReverse, divideY, divideYReverse, down, effects, fill, flex, flexBasis, flexDirection, flexGrow, flexShrink, flexWrap, flexboxGrids, flexboxes, float, fontFamily, fontSize, fontStyle, fontWeight, gap, generateHexAlphaVariants, getAngle, getAnimation, getBorder, getBorderColor, getBorderStyle, getBorderWidth, getBreakpointMax, getBreakpointMin, getColor, getDuration, getFont, getFontSize, getFontWeight, getInset, getLetterSpacing, getLineHeight, getPercent, getPreflightStyles, getPx, getRadius, getRingWidth, getScreens, getShadow, getSize, getSpace, getStates, getTimingFunction, getTransform, getTransition, getTransitionProperty, getVariants, getZIndex, gradientFrom, gradientTo, gradientVia, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridRow, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, grids, height, interactivity, justifyContent, justifyItems, justifySelf, layout, left, letterSpacing, lineHeight, listStylePosition, listStyleType, margin, marginBottom, marginLeft, marginRight, marginTop, maskSize, maxHeight, maxWidth, minHeight, minWidth, mx, my, objectFit, opacity, order, outline, outlineColor, outlineOffset, outlineStyle, outlineWidth, overflow, overflowX, overflowY, overscrollBehavior, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, pointerEvents, position, px, py, resize, right, ring, ringColor, ringInset, rotate, row, rowGap, rpxTransformers, scale, scaleX, scaleY, sizing, skewX, skewY, space$1 as space, spaceX, spaceXReverse, spaceY, spaceYReverse, stroke, style, svg, system, tableLayout, tables, text, textAlign, textDecoration, textOverflow, textShadow, textTransform, th, themeGetter, top, transform, transformOrigin, transforms, transition, transitionDelay, transitionDuration, transitionProperty, transitionTimingFunction, transitions$1 as transitions, translateX, translateY, typography, up, userSelect, verticalAlign, visibility, whiteSpace, width, zIndex };